import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getEmployeeName } from "../api/employees";
// import { getEmployeeName } from "../../services/api"; // Update the path based on your file structure

// Async thunk for fetching employee name
export const fetchEmployeeName = createAsyncThunk(
  "employeeName/fetchEmployeeName",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await getEmployeeName(userId);
      // console.log("response.data", response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create slice
const employeeNameSlice = createSlice({
  name: "employeeName",
  initialState: {
    employeeName: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeName.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeName = action.payload;
      })
      .addCase(fetchEmployeeName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
// export default employeeNameSlice.reducer;
export const getEmployeeNameReducer = employeeNameSlice.reducer;
